import React, { useState, useEffect } from "react";
import { getCurrentDate, formatToDate } from "../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../Extra/SuccessMsg";
import FailedMsg from "../Extra/FailedMsg";

const PpLostTrainInsertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const cols = 16;
  const currentDate = getCurrentDate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(1);
  const [globalDate, setGlobalDate] = useState(currentDate);
  const [show, setShow] = useState(false);
  const [messageDisplay, setMessageDisplay] = useState(false);

  const columnHead = [
    "SCH_DATE",
    "TRAIN_NO",
    "START_DATE",
    "TRAIN_TYPE",
    "OWNG_RLY",
    "RPT_SOURCE",
    "Status",
    "Status_TIME",
    "DIVI",
    "INCIDENT_SECTION	",
    "LOC_FROM",
    "LOC_TO",
    "DET_TYPE",
    "DET_CODE",
    "SUB_CODE",
    "REMARKS",
  ];

  const initializeGrid = (rowCount) =>
    Array(rowCount)
      .fill()
      .map(() => [
        globalDate, // Initialize date with the global date
        ...Array(cols - 1).fill(""),
      ]);

  const [gridData, setGridData] = useState(initializeGrid(rows));

  // Update the grid when global date changes
  useEffect(() => {
    const updatedData = gridData.map((row) => [globalDate, ...row.slice(1)]);
    setGridData(updatedData);
  }, [globalDate]);

  // Display success message
  useEffect(() => {
    if (result?.message === "Data inserted successfully") {
      setMessageDisplay(true);
      setTimeout(() => setMessageDisplay(false), 3000);
    }
  }, [result]);

  // Handle row change
  const handleRowChange = (e) => {
    if (e.target.value < 1) {
      return;
    } else if (e.target.value > 101) {
      return;
    } else {
      const newRowCount = parseInt(e.target.value, 10);

      if (newRowCount < 1) return; // Prevent 0 or negative rows

      if (newRowCount > rows) {
        // Add new rows
        const newRows = initializeGrid(newRowCount - rows);
        setGridData((prevData) => [...prevData, ...newRows]);
      } else if (newRowCount < rows) {
        // Remove excess rows
        setGridData((prevData) => prevData.slice(0, newRowCount));
      }
      setRows(newRowCount);
    }
  };

  const handleChange = (row, col, value) => {
    const newData = [...gridData];
    newData[row][col] = value;
    setGridData(newData);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData("text");
    const rowsData = clipboardData.split("\n").map((row) => row.split("\t"));

    const newGridData = [...gridData];

    rowsData.forEach((row, rIndex) => {
      if (rIndex >= rows) return;

      row.forEach((cell, cIndex) => {
        if (cIndex >= cols - 1) return;

        let value = cell.trim();

        // Format only the 2nd column (index 1) as date
        if (cIndex === 1) {
          value = formatToDate(value); // Ensure date format
        }

        newGridData[rIndex][cIndex + 1] = value;
      });
    });
    setGridData(newGridData);
  };
  const clearAll = () => {
    setGridData(initializeGrid(rows));
  };

  const sendToBackend = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${urlPrefix}insert/pplostdata`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(gridData),
      });

      const dataResult = await response.json();
      setResult(dataResult);
      setLoading(false);
      setShow(true);

      if (result?.insertion) {
        clearAll();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error sending data:", error);
    }
  };
  useEffect(() => {
    if (result?.insertion) {
      clearAll();
    }
  }, [result]);

  return (
    <div className="text-center mt-12 " style={{}}>
      <div className="papaDiv text-start ms-3 me-3">
        <h4 className="ms-4">
          <MdInsertChart /> pp Lost train
        </h4>
        <h5 className="ps-2">
          Insert data in table <b style={{ color: "red" }}>"pp_lost_train"</b>
        </h5>
      </div>

      {/* Dynamic Row Input */}
      <div>
        Add No of Rows
        <input
          type="number"
          min="1"
          max="100"
          onChange={handleRowChange}
          value={rows}
          placeholder="Enter number of rows"
        />
      </div>

      {/* Table Display */}
      <div className="table-responsive">
        <table
          className="table table-striped table-hover"
          border="1"
          cellPadding="1"
          onPaste={handlePaste}
        >
          <thead>
            <tr className="table-dark" style={{ fontSize: "12px" }}>
              {columnHead.map((head, index) => (
                <th key={index} style={{ border: "1px solid gray" }}>
                  {head}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {gridData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, colIndex) => (
                  <td key={colIndex} style={{ border: "1px solid gray" }}>
                    {colIndex === 0 ? (
                      <input
                        type="date"
                        value={globalDate}
                        style={{ width: "110px" }}
                        max={currentDate}
                        onChange={(e) => setGlobalDate(e.target.value)}
                      />
                    ) : colIndex + 1 === 16 ? (
                      <textarea
                        value={cell}
                        style={{ width: "400px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, colIndex, e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        value={cell}
                        style={{ width: "60px" }}
                        onChange={(e) =>
                          handleChange(rowIndex, colIndex, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Success/Failure Message */}
      <div className="p-3">
        {result?.insertion ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          <FailedMsg
            head="Failed"
            message={`${result?.message}, ${result?.error}`}
            show={show}
            setShow={setShow}
          />
        )}
      </div>

      {/* Buttons */}
      <div>
        <button
          className="m-1 btn btn-sm btn-outline-danger"
          onClick={clearAll}
        >
          <FaEraser /> Clear All
        </button>
        <button
          className={`m-1 btn btn-sm btn-outline-success ${
            loading ? "disabled" : ""
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default PpLostTrainInsertion;
